import React from "react";
import { ImCodepen, ImDribbble, ImLinkedin2 } from "react-icons/im";

import ProfileImg from "../../../Assets/Misc/profile-pic-alban_bujupaj.webp";

import { Link } from "react-router-dom";

import "./Footer.scss";
const d = new Date();
let year = d.getFullYear();

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="year">
          <span className="year__watermark">Ⓒ {year}</span>
          <span className="text">
            Mainly Looking to work with detail oriented and user-centered
            projects. <br /> {/* Also, in creative agency */}
          </span>
        </div>

        <div className="contact-me">
          <h4> I'm Available Contact me </h4>

          <Link to={"mailto:abujupaj@gmail.com"}>
            <span className="online-sign"></span>
            <img src={ProfileImg} alt="alban bujupaj portfolio" />
            <a
              to="#"
              onClick={(e) => {
                window.location.href = 'mailto:abujupaj@gmail.com';
                e.preventDefault();
              }}
            >
              abujupaj@gmail.com
            </a>
          </Link>
          <span className="reply-msg">Usually replay within a day</span>
        </div>
        <ul className="links">
          <li>
            <Link
              className="dribbble"
              to={{ pathname: "http://dribbble.com/albanbujupaj" }}
              target="_blank"
              without
              rel="noreferrer"
            >
              <ImDribbble />
            </Link>
            {/* Dribbble */}
          </li>
          <li>
            <Link
              className="linkedin"
              to={{ pathname: "https://www.linkedin.com/in/alban-bujupaj-65100163" }}
              target="_blank"
              without
              rel="noreferrer"
            >
              <ImLinkedin2 />
            </Link>
            {/* linkedIn */}
          </li>
          <li>
            <Link
              className="twitter"
              to={{ pathname: "https://codepen.io/abujupaj" }}
              target="_blank"
              without
              rel="noreferrer"
            >
              <ImCodepen />
            </Link>
            {/* linkedIn */}
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
